import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
});

// ----------------------------
// REQUEST INTERCEPTOR
// ----------------------------
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log('API Request:', {
      url: config.url,
      method: config.method,
    });

    return config;
  },
  (error) => Promise.reject(error)
);

// ----------------------------
// RESPONSE INTERCEPTOR
// ----------------------------
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    console.error('API Error:', {
      url: originalRequest?.url,
      status: error.response?.status,
    });

    // Check if 401 & not already retried
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url?.includes('/users/login/') &&
      !originalRequest.url?.includes('/users/refresh/')
    ) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refreshToken');

        if (!refreshToken) {
          throw new Error('No refresh token available');
        }

        const apiBaseUrl = (
          process.env.REACT_APP_API_URL || '/api'
        ).replace(/\/+$/, '');

        const response = await axios.post(
          `${apiBaseUrl}/users/refresh/`,
          { refresh: refreshToken }
        );

        const { access, refresh } = response.data;

        // Save new tokens
        localStorage.setItem('accessToken', access);
        if (refresh) {
          localStorage.setItem('refreshToken', refresh);
        }

        // Update header & retry request
        originalRequest.headers.Authorization = `Bearer ${access}`;

        return api(originalRequest);

      } catch (refreshError) {
        console.log('Refresh failed, logging out...');

        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');

        window.location.href = '/login';

        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;